module.exports = __webpack_public_path__ + "resources/img/sp_common.8530ec8148679a5767b1af4ba5cb19e4.png";